import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { createQueryClient } from "@veorest/api-client";
import { registerSW, registerAutoFlush } from "@veorest/pwa";
import "../../../packages/ui/src/styles.css";
import App from "./App";
import "./index.css";

const queryClient = createQueryClient();
registerSW("/sw.js");
registerAutoFlush();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
